import { BpkExtraLargeSpinner } from '@skyscanner-internal/backpack-web/bpk-component-spinner';
import { useSelector } from 'react-redux';
import SizeMe from 'react-sizeme';

import { isLoading, isUserDateSelectionAllowed } from '../../selectors';

import { ChartWithScale } from './ChartWithScale';

import type { Direction } from '../../selectors/types';

import './ChartWithLoading.scss';

const SizedChart = SizeMe()(ChartWithScale);

type ScaledChartWithLoadingProps = {
  currencyFormatter: (price: number) => string;
  dateFormatter: (date: Date) => string;
  dayOfWeekNameProvider: (date: number | string) => string;
  direction: Direction;
};

export const ScaledChartWithLoading = ({
  currencyFormatter,
  dateFormatter,
  dayOfWeekNameProvider,
  direction,
}: ScaledChartWithLoadingProps) => {
  const flightsLoading = useSelector(isLoading);
  const dateSelectionAllowed = useSelector(isUserDateSelectionAllowed);

  const hideGrid = flightsLoading || !dateSelectionAllowed;

  const dataState = hideGrid ? '--data-loading' : '--data-loaded';

  return (
    <div className="month-view-chart-wrapper">
      <BpkExtraLargeSpinner className={`month-view-spinner${dataState}`} />
      <SizedChart
        hideScaleForWidthBelowPx={600}
        direction={direction}
        currencyFormatter={currencyFormatter}
        dateFormatter={dateFormatter}
        dayOfWeekNameProvider={dayOfWeekNameProvider}
        className={`month-view-chart${dataState}`}
      />
    </div>
  );
};
